import { ApplicationDocumentModel } from '../../../models/ApplicationDocumentModel'
import { MilestoneModel } from '../../../models/MilestoneModel';
//import { MilestoneReport } from '../../../models/MilestoneReport';
import { MilestoneReportModel } from '../../../models/MilestoneReportModel';

export interface DocumentTypeInfo {
    code: string
    parentFolderName: string
    folderName: { (model: MilestoneModel, item: string): string }
    reducer: { (model: MilestoneReportModel): string[] }
    title: string
    description: string
    required: { (model: MilestoneReportModel, item: string): boolean }
    quickList: { (model: MilestoneReportModel, item: string): boolean }
    multipleFiles: { (model: MilestoneModel, item: string): boolean }
    mlClasses: string[]
    moreInfo?: string
}

export const isMilestoneReportDocumentPendingScoring = (document: ApplicationDocumentModel): boolean => {
  const docType = documentTypeInfo.filter((r) => r.code === document.code)

  if (docType.length > 0) {
    if (docType[0].mlClasses == null) return false

    return document.mlScore == null
  }

  return false
}

export const CODE_INFECTED = 'infected'

export const isMilestoneReportDocumentValid = (document: ApplicationDocumentModel): boolean => {
  const docType = documentTypeInfo.filter((r) => r.code === document.code)

  if (docType.length > 0) {
    if (docType[0].mlClasses == null) return true

    return docType[0].mlClasses.some((x) => x === document.mlCode)
  }

  return true
}

export const isMilestoneDocumentInfected = (document: ApplicationDocumentModel): boolean => document.mlCode === CODE_INFECTED

export const documentTypeInfo: DocumentTypeInfo[] = [
  // Declaration
  {
    code: 'rep_body_invoice',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => (m.grantAgreementDetailModel.grantType === 'Representative Body' ? [''] : []),
    title: 'Invoice (or other supporting documentation) for the largest expenditure item',
    description: 'Invoice (or other supporting documentation) for the largest expenditure item',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  {
    code: 'tier_1_invoice',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => (m.grantAgreementDetailModel.grantType === 'Tier 1' ? [''] : []),
    title: 'Invoice (or other supporting documentation) for the largest expenditure item',
    description: 'Invoice (or other supporting documentation) for the largest expenditure item',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  {
    code: 'tier_2_invoice',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => (m.grantAgreementDetailModel.grantType === 'Tier 2' ? [''] : []),
    title: 'Invoice (or other supporting documentation) for the largest expenditure item',
    description: 'Invoice (or other supporting documentation) for the largest expenditure item',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  {
    code: 'tier_3_invoice',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => ( (m.grantAgreementDetailModel.grantType === 'Tier 3' )? [''] : []),
    title: 'Invoice (or other supporting documentation) for the largest expenditure item',
    description: 'Invoice (or other supporting documentation) for the largest expenditure item',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  { // Only required if there is a overseas representative entry in the editable expenditure table
    code: 'tier_3_invoice_overseas_representative',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => ( (m.grantAgreementDetailModel.grantType === 'Tier 3' && 
      m.milestoneModel.eligibleExpenditureCategories.filter( (eec) => {
        return eec.eligibleExpenditureCategoryCrmID === m.eligibleExpenditureCategoryGuidKeyMappingList["OverseasRep"]
      }).length > 0 )? [''] : []),
    title: 'Largest invoice (or other supporting documentation) paid to the overseas representative',
    description: 'Largest invoice (or other supporting documentation) paid to the overseas representative',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  { // new May/2023: similar to above item, make Bank-Statement mandatory for Tier3 + OverseasRep;
    code: 'tier_3_bankstmt_overseas_rep',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => ((m.grantAgreementDetailModel.grantType === 'Tier 3' &&
        m.milestoneModel.eligibleExpenditureCategories.filter((eec) => {
            return eec.eligibleExpenditureCategoryCrmID === m.eligibleExpenditureCategoryGuidKeyMappingList["OverseasRep"]
        }).length > 0) ? [''] : []),
    title: 'Bank statement for largest invoice paid to the overseas representative',
    description: 'Bank statement for largest invoice paid to the overseas representative',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  { // Only required if there is a consultant entry in the editable expenditure table
    code: 'tier_3_invoice_consultant',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => ( (m.grantAgreementDetailModel.grantType === 'Tier 3' && 
      m.milestoneModel.eligibleExpenditureCategories.filter( (eec) => {
        return eec.eligibleExpenditureCategoryCrmID == m.eligibleExpenditureCategoryGuidKeyMappingList["Consultant"]    
      }).length > 0 )? [''] : []),
    title: 'Largest invoice (or other supporting documentation) paid to the consultant',
    description: 'Largest invoice (or other supporting documentation) paid to the consultant',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  { // new May/2023: similar to above item, make Bank-Statement mandatory for Tier3 + Consultant;
    code: 'tier_3_bankstmt_consultant',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => ((m.grantAgreementDetailModel.grantType === 'Tier 3' &&
        m.milestoneModel.eligibleExpenditureCategories.filter((eec) => {
            return eec.eligibleExpenditureCategoryCrmID == m.eligibleExpenditureCategoryGuidKeyMappingList["Consultant"]
        }).length > 0) ? [''] : []),
    title: 'Bank statement for largest invoice paid to the consultant',
    description: 'Bank statement for largest invoice paid to the consultant',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  { // only required when there is an entry in the overseas grid
    code: 'overseas_representative_agreement',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => (m.milestoneModel.overseasRepresentatives.length > 0 ? [''] : []),
    title: 'Overseas representative agreement/contract',
    description: 'Overseas representative agreement/contract',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
  { // only required when there is an entry in the consultant grid
    code: 'consultant_agreement',
    parentFolderName: '07 Milestone Report',
    folderName: (m) => `Milestone Report ${(new Date(m.grantYearStartDate)).getFullYear()}-${(new Date(m.grantYearEndDate)).getFullYear().toString().substring((new Date(m.grantYearEndDate)).getFullYear().toString().length - 2)}`,
    reducer: (m) => (m.milestoneModel.milestoneConsultants.length > 0 ? [''] : []),
    title: 'Consultant agreement/contract',
    description: 'Consultant agreement/contract',
    required: (m) => true,
    quickList: (m) => true,
    multipleFiles: (m) => false,
    mlClasses: [],
  },
]
